import axios from "axios";


let base = "/cct"; //本地代理
let first = 0

export default {
    install(Vue, options) {
        Vue.prototype.$postJSON = function (url, param, func) {
            axios.post(`${base + url}`, param).then((res) => {
                func && func(res.data)
            })
        }
        Vue.prototype.$getJSON = function (url, param, func, failFunc) {
            // qs.stringify(param)
            axios.get(`${base + url}`, { params: param }).then((res) => {
                func && func(res.data)
            }, (error) => {
                failFunc && failFunc(error)
            })
        }
        Vue.prototype.$getUrlPath = function (urlPath) {
            urlPath = base + urlPath;
            return urlPath;
        }
        Vue.prototype.$debounce = function (fn, t) {
            let timer
            return function () {
                let _this = this
                let _arguments = arguments

                if (timer) {
                    clearTimeout(timer)
                }

                timer = setTimeout(() => {
                    fn.apply(_this, _arguments)
                }, t)
            }
        }
        // 节流器弹框
        Vue.prototype.throttleMsg = function (msgs, type, delay) {
            if (!first) {
                this.$message({
                    message: msgs,
                    type: type,
                })
                setTimeout(() => {
                    first = 0
                }, delay)
                first++
            } else {
                first++
            }
        }
    }
}